var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-carousel',_vm._l((_setup.tours),function(tour){return _c('el-carousel-item',[_c('div',{staticClass:"flex flex-vertical fit"},[_c('div',{staticClass:"flex image"},[_c('el-image',{attrs:{"src":tour,"fit":"fit","preview-src-list":_setup.tours}})],1)])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }